var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_932_3068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_932_3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 26.6562C14.7083 26.6562 14.4167 26.6042 14.125 26.5C13.8333 26.3958 13.5729 26.2396 13.3438 26.0312C11.9896 24.7812 10.7917 23.5625 9.75 22.375C8.70833 21.1875 7.83854 20.0365 7.14062 18.9219C6.44271 17.8073 5.91146 16.7344 5.54688 15.7031C5.18229 14.6719 5 13.6875 5 12.75C5 9.625 6.00521 7.13542 8.01563 5.28125C10.026 3.42708 12.3542 2.5 15 2.5C17.6458 2.5 19.974 3.42708 21.9844 5.28125C23.9948 7.13542 25 9.625 25 12.75C25 13.6875 24.8177 14.6719 24.4531 15.7031C24.0885 16.7344 23.5573 17.8073 22.8594 18.9219C22.1615 20.0365 21.2917 21.1875 20.25 22.375C19.2083 23.5625 18.0104 24.7812 16.6562 26.0312C16.4271 26.2396 16.1667 26.3958 15.875 26.5C15.5833 26.6042 15.2917 26.6562 15 26.6562ZM15 15C15.6875 15 16.276 14.7552 16.7656 14.2656C17.2552 13.776 17.5 13.1875 17.5 12.5C17.5 11.8125 17.2552 11.224 16.7656 10.7344C16.276 10.2448 15.6875 10 15 10C14.3125 10 13.724 10.2448 13.2344 10.7344C12.7448 11.224 12.5 11.8125 12.5 12.5C12.5 13.1875 12.7448 13.776 13.2344 14.2656C13.724 14.7552 14.3125 15 15 15Z",
    fill: "#79747E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.a77c28b7e7fd6a1f020e721e65c5c9e1.svg";
export { ForwardRef as ReactComponent };